
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class AssetEsperienzeGrid extends Serenity.EntityGrid<AssetEsperienzeRow, any> {
        protected getColumnsKey() { return AssetEsperienzeColumns.columnsKey; }
        protected getDialogType() { return AssetEsperienzeClonableDialog; }
        protected getIdProperty() { return AssetEsperienzeRow.idProperty; }
        protected getInsertPermission() { return AssetEsperienzeRow.insertPermission; }
        protected getLocalTextPrefix() { return AssetEsperienzeRow.localTextPrefix; }
        protected getService() { return AssetEsperienzeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

            this.openDialogsAsPanel = true;
        }
    }
}